import { render, staticRenderFns } from "./createCaixa.vue?vue&type=template&id=156b03ca"
import script from "./createCaixa.vue?vue&type=script&lang=js"
export * from "./createCaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports